import './style.scss';

// Block stores
import './blocks/Layout/MediaScroll/front.js';

let domReady = window?.wp?.domReady;

// Fallback if wp.domReady is not available
if (!domReady) {
  console.warn('wp.domReady not found, using fallback.');
  domReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  };
}

// Auto-scroll to new Q&A items
function initAutoScrollToNewQA() {
  const qaList = document.querySelector('.wp-block-post-template');
  if (!qaList) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.tagName === 'LI') {
            // Scroll to the newly added item
            node.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    });
  });

  observer.observe(qaList, {
    childList: true,
    subtree: false
  });
}

domReady(() => {
  initAutoScrollToNewQA();
});